














import { Vue, Component } from 'vue-property-decorator';
import CamaraHistorico from '@/pantallas/Camaras/Historico/CamaraHistorico.vue';

@Component({
  components: { HistoricoComponent: CamaraHistorico },
})
export default class CamaraHistoricoPantalla extends Vue {}
